module.exports = __webpack_public_path__ + "static/media/modal-close-btn.50536eea.svg";